import React, { RefObject } from "react";
import TpCarouselCard from "../TpCarouselCard";
import { ContentItem } from "../../../../utils/contentMappers";

interface BannerSectionProps {
  items: ContentItem[];
  loading: boolean;
  carouselRef: RefObject<HTMLDivElement>;
  activeCardIndex: number;
  isPaused: boolean;
  onCardClick: (index: number) => void;
  setIsPaused: (isPaused: boolean) => void;
  extendedItems: ContentItem[];
  showEmptyState?: boolean;
}

const BannerSection: React.FC<BannerSectionProps> = ({
  items,
  loading,
  carouselRef,
  activeCardIndex,
  isPaused,
  onCardClick,
  setIsPaused,
  extendedItems,
  showEmptyState = true,
}) => {
  // Render empty state component
  const renderEmptyState = () => (
    <div className="bg-gray-50 rounded-xl p-6 my-4 text-center">
      <h3 className="text-gray-500 text-lg font-medium">
        No content available in selected speciality
      </h3>
      <p className="text-gray-400 mt-2">Featured content will appear here</p>
    </div>
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center w-full py-8">
        <div className="animate-pulse bg-gray-200 rounded-xl h-48 w-80"></div>
      </div>
    );
  }

  if (items.length === 0 && showEmptyState) {
    return renderEmptyState();
  }

  return (
    <div
      ref={carouselRef}
      className="w-full py-4 pl-4 scroll-smooth"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="py-4">
        <span 
          style={{
            color: '#A2A2A8',
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: '16px'
          }}
        >
          Latest by category
        </span>
      </div>
      <div className="relative overflow-hidden">
        <div 
          className="flex gap-4 overflow-x-auto scrollbar-hide"
          style={{ 
            scrollSnapType: 'x mandatory',
            scrollBehavior: 'smooth',
            paddingRight: 'calc(50% - 9.5rem)',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {items.map((item: ContentItem, index: number) => (
            <div 
              key={item.id} 
              className="flex-shrink-0"
              style={{ 
                scrollSnapAlign: 'center',
                width: '17rem'
              }}
            >
              <div 
                className="carousel-card transition-all duration-500 ease-in-out"
                onClick={() => onCardClick(index)}
              >
                <TpCarouselCard {...item} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
